import styled, { css } from 'styled-components';
import { colors, fontFamily } from 'components/styles/_variables';
import { respondTo } from '../../styles/_respondTo';

export const InputStyled = styled.input`
  webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 100%;
  height: 100%;

  border-radius: 6px;
  border: solid 0.5px
    ${({ failed }) => (failed ? colors.theme.danger : colors.elements.primary)};
  padding: 18px 10px 5px 10px;
  font-family: ${fontFamily.primary};
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.13;
  letter-spacing: -0.27px;
  color: #636262;
  ${({ multiline }) =>
    multiline &&
    css`
      height: 130px;
      multiline: true;
    `}
  ${respondTo.desktop`
    max-width: 320px;
  `}
  &::-webkit-input-placeholder {
    /* Edge */
    opacity: 0.6;
  }

  &:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    opacity: 0.6;
  }

  &::placeholder {
    opacity: 0.6;
  }

  &:disabled {
    cursor: not-allowed;
  }
  -moz-appearance: textfield;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const SuffixWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 33px;
  cursor: pointer;
  ${({ variant }) =>
    variant === 'password' &&
    css`
      position: absolute;
      right: 0;
      margin-right: 20px;
      height: 100%;
      cursor: pointer;
    `}
`;

export const MultiLangWrapper = styled.div`
  display: flex;
  padding-bottom: 20px;
  margin-top: 5px;
  justify-content: flex-end;
  //position: absolute;
  //right: 0;
  //top: 100%;
`;

export const MultiLangItem = styled.span`
  margin-right: 4px;
  cursor: pointer;
  position: relative;
  padding: 2px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  ${({ isActive = false }) =>
    isActive &&
    css`
      box-shadow: 0 0 0 1px #ff7828;
    `}
`;

export const InsideSuffixWrapper = styled.div``;
